import { jsx as _jsx } from "react/jsx-runtime";
import { ImageList, ImageListItem } from '@mui/material';
import { usePagination } from '~/shared/hooks/usePagination';
import { useTagsHandler } from '~/shared/hooks/useTagsHandler';
export const ImagesList = ({ itemData, clickImageHandler, offset }) => {
    usePagination(offset);
    useTagsHandler();
    return (_jsx(ImageList, { cols: 2, sx: { overflow: 'hidden' }, children: itemData.map((item, index) => (_jsx(ImageListItem, { children: _jsx("img", { src: `${item.img}?w=164&h=164&fit=crop&auto=format`, srcSet: `${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`, alt: item.title, loading: index > 10 ? 'lazy' : undefined, onClick: () => clickImageHandler && clickImageHandler(item, index) }) }, index))) }));
};
